export class IntroducerRepAssessment {

    private id!: number;
    private dateofinterview!: string;
    private remarkContent!: string;
    private updatedbyrole!: string;
    private commissionreprsentatitve!: string;
    private commissionintroducer!: string;
    private remarkid!: number;
    private rm_not_applicable!: boolean;
    private rm_declaration_date!: string;

    constructor() { }

    // Getters & Setters
    getId(): number {
        return this.id;
    }
    setId(id: number) {
        this.id = id;
    }

    getRemarkId(): number {
        return this.remarkid;
    }
    setRemarkId(remarkid: number) {
        this.remarkid = remarkid;
    }

    getDateofInterview(): string {
        return this.dateofinterview;
    }

    setDateofInterview(dateofinterview: string) {
        this.dateofinterview = dateofinterview;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }

    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getupdatedbyrole(): string {
        return this.updatedbyrole;
    }

    setupdatedbyrole(updatedbyrole: string) {
        this.updatedbyrole = updatedbyrole;
    }

    getRm_not_applicable(): boolean {
        return this.rm_not_applicable;
    }

    setRm_not_applicable(rm_not_applicable: boolean) {
        this.rm_not_applicable = rm_not_applicable;
    }

    getRm_declaration_date(): string {
        return this.rm_declaration_date;
    }

    setRm_declaration_date(rm_declaration_date: string) {
        this.rm_declaration_date = rm_declaration_date;
    }

    getCommissionReprsentatitve(): string {
        return this.commissionreprsentatitve;
    }

    setCommissionReprsentatitve(commissionreprsentatitve: string) {
        this.commissionreprsentatitve = commissionreprsentatitve;
    }


    getCommissionIntroducer(): string {
        return this.commissionintroducer;
    }

    setCommissionIntroducer(commissionintroducer: string) {
        this.commissionintroducer = commissionintroducer;
    }


    toString() {
        return JSON.stringify({
            id: this.getId(),
            date_of_interview: this.getDateofInterview(),
            commission_reprsentatitve:this.getCommissionReprsentatitve(),
            commission_introducer:this.getCommissionIntroducer(),
            rm_declaration_date: this.getRm_declaration_date(),
            rm_not_applicable: this.getRm_not_applicable(),
            remark_id: this.getRemarkId(),
            remarkContent: this.getRemarkContent(),
            updated_by_role: this.getupdatedbyrole()
        });
    }
}
